import type { Shaped } from './SelectionInspector';

export const STROKE_PATTERNS = [
  { id: 'none', label: 'No stroke', dash: undefined },
  { id: 'solid', label: 'Solid', dash: undefined },
  { id: 'dashed', label: 'Dashed', dash: '10 5' },
  { id: 'short-dash', label: 'Short dash', dash: '5 3' },
  { id: 'dotted', label: 'Dotted', dash: '0 6' },
] as const;
type Pattern = (typeof STROKE_PATTERNS)[number]['id'];

export function strokePattern(node: Shaped): Pattern {
  if (!node.strokes?.some(paint => paint.visible !== false) || node.strokeStyle?.weight === 0) return 'none';
  const style = node.strokeStyle ?? {};
  if (!style.dashes?.some(value => value > 0)) return 'solid';
  if (style.cap === 'round' && style.dashes[0] === 0) return 'dotted';
  return (style.dashes[0] ?? 0) <= (style.weight ?? 1) * 2 ? 'short-dash' : 'dashed';
}

/** Hiding keeps all stroke paints and geometry available when the stroke is restored. */
export function strokePatternPatch(node: Shaped, pattern: Pattern) {
  const style = node.strokeStyle ?? {};
  const weight = Math.max(1, style.weight ?? 1);
  const paints = node.strokes?.length ? node.strokes : [{ type: 'solid' as const, color: { r: 0, g: 0, b: 0, a: 1 }, opacity: 1, blendMode: 'normal' as const }];
  if (pattern === 'none') return { strokes: paints.map(paint => ({ ...paint, visible: false })) };
  const dash = (multiple: number) => Math.min(10_000, weight * multiple);
  const dashes = pattern === 'solid' ? [] : pattern === 'dotted' ? [0, dash(2)] : pattern === 'short-dash' ? [dash(2), dash(2)] : [dash(4), dash(2)];
  return { strokes: paints.map(paint => ({ ...paint, visible: true })), strokeStyle: { ...style, weight, dashes, cap: pattern === 'dotted' ? 'round' : 'butt' } };
}
